import React from 'react';
import { Video, FileText, Globe } from 'lucide-react';
export function HeroSection() {
  return <div className="relative bg-white overflow-hidden" data-id="element-131">
      <div className="max-w-7xl mx-auto" data-id="element-132">
        <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32" data-id="element-133">
          <svg className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2" fill="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" data-id="element-134">
            <polygon points="50,0 100,0 50,100 0,100" data-id="element-135" />
          </svg>
          <div className="relative pt-6 px-4 sm:px-6 lg:px-8" data-id="element-136"></div>
          <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28" data-id="element-137">
            <div className="sm:text-center lg:text-left" data-id="element-138">
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl" data-id="element-139">
                <span className="block xl:inline" data-id="element-140">
                  Transform YouTube videos
                </span>{' '}
                <span className="block text-indigo-600 xl:inline" data-id="element-141">
                  into powerful content
                </span>
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0" data-id="element-142">
                Automatically transcribe YouTube videos, convert them into
                engaging blog posts, and dub your videos into multiple languages
                with perfect subtitles.
              </p>
              <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start" data-id="element-143">
                <div className="rounded-md shadow" data-id="element-144">
                  <a href="#" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10" data-id="element-145">
                    Get started
                  </a>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3" data-id="element-146">
                  <a href="#how-it-works" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 md:py-4 md:text-lg md:px-10" data-id="element-147">
                    How it works
                  </a>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2" data-id="element-148">
        <img className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src="https://images.unsplash.com/photo-1516110833967-0b5716ca1387?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" alt="Video editing workspace with computer screens" data-id="element-149" />
      </div>
    </div>;
}